<template>
  <div class="page_background">
      <div class="heading"> Vielen Danke für Ihre Registrierung! </div>
      <p class="page_descrition"> Wir prüfen gerade Ihre Zugangsberechtigung und werden Sie in Kürze per Email informieren.  </p>
      <div >
        <v-btn class="btn-new" @click="$router.push('/login')">
          <div style="color:black;">ZurückButton</div>
        </v-btn>
      </div>
  </div>
</template>

<script>

  export default {
    name: "ErrorPage"
  }
</script>

<style scoped>
  .btn-new {
    border: none;
    cursor: pointer;
    border-radius: 8px;
    width: 158px;
    height: 38px;
    letter-spacing: 0px;
    font-size: 17px;
  }

</style>